import React from 'react';

const About = ({
  data: { personalInfo, skills, pricingPlans, clients, testimonials, funFacts },
}) => (
  <div className="card-inner active">
    <div className="card-wrap">
      <div className="content about">
        <div className="title">
          <span className="first-word">About</span> Me
        </div>
        <div className="content-space">
          <div className="row row-margin">
            <div className="col-md-12">
              <div className="text-box">
                <p>
                  <strong>Hello! I'm {personalInfo.name}.</strong> {personalInfo.description}
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div className="info-list">
                <ul>
                  {personalInfo.details.map((detail, index) => (
                    <li key={index}>
                      <strong>{detail.label} . . . . .</strong> {detail.value}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content services">
        <div className="title">
          <span className="first-word">Technical</span> Arsenal
        </div>
        <div className="content-space noSpace border-line-v">
          <div className="row row-margin">
            {skills.map((skill, index) => (
              <div key={index} className="col-md-6 colSpace border-line-h">
                <div className="service-item">
                  <div className="icon">
                    <span className={`fa ${skill.icon}`}></span>
                  </div>
                  <div className="name">
                    <span>{skill.name}</span>
                  </div>
                  <div className="desc">
                    <div>
                      <p>{skill.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <div className="content pricing">
        <div className="title">Pricing</div>
        <div className="content-space border-line-v">
          <div className="row pricing-items">
            {pricingPlans.map((plan, index) => (
              <div key={index} className="col-md-6">
                <div className="pricing-item">
                  <div className="icon">
                    <i className={`fa ${plan.icon}`}></i>
                  </div>
                  <div className="name">{plan.name}</div>
                  <div className="amount">
                    <span className="dollar">$</span>
                    <span className="number">{plan.price}</span>
                    <span className="period">hour</span>
                  </div>
                  <div className="feature-list">
                    <ul>
                      {plan.features.map((feature, featureIndex) => (
                        <li
                          key={featureIndex}
                          className={plan.disabledFeatures.includes(feature) ? 'disable' : ''}
                        >
                          {feature} {feature === 'Photography' && <strong>new</strong>}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="lnks">
                    <a href={index === 0 ? '#contacts' : '#!'} className="lnk">
                      <span className="text">Buy {plan.name}</span>
                      <i className="fa fa-chevron-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}
      {/* <div className="content">
        <div className="title">Clients</div>
        <ul className="client-logo">
          {clients.map((client, index) => (
            <li key={index}>
              <div className="client-item">
                <div className="image">
                  <a target="_blank" href="#!" rel="noopener noreferrer">
                    <img src={client} alt="" />
                  </a>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div> */}
      <div className="content testimonials">
        <div className="title">{testimonials.title}</div>
        <div className="featured-Slider">
          <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
              {testimonials.items.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#carouselExampleIndicators"
                  data-bs-slide-to={index}
                  className={index === 0 ? 'active' : ''}
                  aria-current={index === 0 ? 'true' : 'false'}
                  aria-label={`Slide ${index + 1}`}
                ></button>
              ))}
            </div>
            <div className="carousel-inner">
              {testimonials.items.map((testimonial, index) => (
                <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                  <div className="revs-item">
                    <div className="text">{testimonial.text}</div>
                    <div className="user">
                      <div className="img">
                        <img src={testimonial.image} alt="" />
                      </div>
                      <div className="info">
                        <div className="name">{testimonial.name}</div>
                        <div className="company">{testimonial.position}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
      <div className="content funfuct">
        <div className="title">Fun Fact</div>
        <ul className="funFact-section">
          {funFacts.map((fact, index) => (
            <li key={index}>
              <div className="fuct-item">
                <div className="icon">
                  <span className={`fa ${fact.icon}`}></span>
                </div>
                <div className="name">{fact.text}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default About;
